module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Crown-daceec0a07a7dd9fb6fece79a1902f8f.svg";